// extracted by mini-css-extract-plugin
module.exports = {"header":"i_X4","description":"i_X5","title":"i_X6","subtitle":"i_X7"};